const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '';

async function parseJson(response) {
  try {
    return await response.json();
  } catch {
    return null;
  }
}

export async function fetchTipoConceptos({ signal } = {}) {
  const response = await fetch(`${API_BASE_URL}/tipo-conceptos`, {
    method: 'GET',
    signal,
  });
  if (!response.ok) {
    throw new Error(`Request failed (${response.status}) ${response.statusText}`);
  }
  const payload = await response.json();
  return payload?.data ?? [];
}

export async function createTipoConcepto({ tpConcepto, deTipoConcepto }) {
  const response = await fetch(`${API_BASE_URL}/tipo-conceptos`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      tp_concepto: tpConcepto,
      de_tipo_concepto: deTipoConcepto,
    }),
  });
  const body = await parseJson(response);
  return { ok: response.ok, status: response.status, data: body?.data ?? null };
}

export async function updateTipoConcepto(tpConcepto, deTipoConcepto) {
  const response = await fetch(`${API_BASE_URL}/tipo-conceptos/${tpConcepto}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ de_tipo_concepto: deTipoConcepto }),
  });
  const body = await parseJson(response);
  return { ok: response.ok, status: response.status, data: body?.data ?? null };
}

export async function toggleTipoConceptoStatus(tpConcepto) {
  const response = await fetch(
    `${API_BASE_URL}/tipo-conceptos/${tpConcepto}/anular`,
    { method: 'PATCH' },
  );
  const body = await parseJson(response);
  return { ok: response.ok, status: response.status, data: body?.data ?? null };
}